// extracted by mini-css-extract-plugin
export default {"player":"styles---player---rjPdl","placeholder":"styles---placeholder---k7TYa","preview":"styles---preview---CozNf"};